import api from '@/api'

const state = {
  cleanlinessInspections: [],
  cleanlinessInspectionDetails: [],
  cleanlinessInspectionFile: {},
  cleanlinessInspectionDetailsFile: {}
}

const getters = {
  cleanlinessInspections: state => state.cleanlinessInspections,
  cleanlinessInspectionDetails: state => state.cleanlinessInspectionDetails,
  cleanlinessInspectionFile: state => state.cleanlinessInspectionFile,
  cleanlinessInspectionDetailsFile: state => state.cleanlinessInspectionDetailsFile
}

const mutations = {
  SET_CLEANLINESS_INSPECTIONS(state, payload) {
    state.cleanlinessInspections = payload
  },
  SET_CLEANLINESS_INSPECTION_DETAILS(state, payload) {
    state.cleanlinessInspectionDetails = payload
  },
  SET_CLEANLINESS_INSPECTION_FILE(state, payload) {
    state.cleanlinessInspectionFile = payload
  },
  SET_CLEANLINESS_INSPECTION_DETAILS_FILE(state, payload) {
    state.cleanlinessInspectionDetailsFile = payload
  }
}

const actions = {
  async fetchCleanlinessInspections({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage || 1,
        limit: filterConfig.pageSize || 10,
        ...payload
      }
      const { data } = await api.getHoldHatchCleanliness(filter)

      if (data.error) {
        commit('SET_CLEANLINESS_INSPECTIONS', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }
      commit('SET_CLEANLINESS_INSPECTIONS', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
      return data.data
    } catch (error) {
      throw error
    }
  },
  async fetchCleanlinessInspectionDetails({ commit }, id) {
    try {
      const { data } = await api.getHoldHatchCleanlinessDetails(id)
      if (data.error) {
        commit('SET_CLEANLINESS_INSPECTION_DETAILS', [])
        return
      }
      commit('SET_CLEANLINESS_INSPECTION_DETAILS', data)
    } catch (error) {
      throw error
    }
  },
  async downloadCleanlinessInspection({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await api.getHoldHatchCleanlinessExcelDownload({
        search: filterConfig.search,
        ...payload})
      if (response) {
        commit('SET_CLEANLINESS_INSPECTION_FILE', response)
      }
    } catch (err) {
      throw err
    }
  },
  async downloadCleanlinessInspectionDetails({ commit }, id, params) {
    try {
      const response = await api.getHoldHatchCleanlinessDetailsExcelDownload(id, params)
      if (response) {
        commit('SET_CLEANLINESS_INSPECTION_DETAILS_FILE', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetCleanlinessInspectionFile({ commit }) {
    commit('SET_CLEANLINESS_INSPECTION_FILE', {})
  },
  resetCleanlinessInspectionDetailsFile({ commit }) {
    commit('SET_CLEANLINESS_INSPECTION_DETAILS_FILE', {})
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
